import React from 'react';
// import sections
import Hero from '../components/sections/Hero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Testimonial from '../components/sections/Testimonial';
import Cta from '../components/sections/Cta';
// import Service from '../Services';
import Sliders from '../components/Sliders'


const Home = () => {

  return (
    <>
      <Hero className="illustration-section-01" />
      {/* <Sliders /> */}
      <FeaturesTiles />
      {/* <Service /> */}
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      <Testimonial topDivider />
      <Cta split />
    </>
  );
}

export default Home;